import React, { useState, useEffect, useCallback } from 'react';

const ImageNavigator = ({ images,index,closeModal }) => {
  const [currentIndex, setCurrentIndex] = useState(index);

  const prevImage = useCallback(() => {
    setCurrentIndex(i => (i - 1 + images.length) % images.length);
  }, [images.length]);

  const nextImage = useCallback(() => {
    setCurrentIndex(i => (i + 1) % images.length);
  }, [images.length]);

  const handleKeyDown = useCallback(
    e => {
      if (e.key === 'ArrowLeft') prevImage();
      if (e.key === 'ArrowRight') nextImage();
      if (e.key === 'Escape') closeModal();
    },
    [ prevImage, nextImage]
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return (
    <>
        <div className="modal fade show image-navigator" style={{ display: 'block',backgroundColor:"rgba(0, 0, 0,0.7)" }} onClick={closeModal}>
            <div className="fade show" onClick={e => e.stopPropagation()}></div>

            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content position-relative bg-transparent border-0" onClick={e => e.stopPropagation()}>
                    <button type="button" className="btn-close btn-close-white position-absolute top-0 end-0 m-3" onClick={closeModal}></button>
                    <div className='swiper-button-prev' onClick={prevImage}></div>                
                    <img src={images[currentIndex].url} alt={images[currentIndex]} className="w-100"/>                    
                    <div className='swiper-button-next' onClick={nextImage}></div>
                    <div className="modal-footer justify-content-center bg-dark text-white">
                        {images[currentIndex].alt}
                    </div>
                </div>
            </div>
        </div>
    </>
  );
};

export default ImageNavigator;